import { core as appClientCore } from '@edf-pkg/app-client';

import { axios } from '$app-web/api/axios';
import { Session } from '$app-web/types';

import { Endpoints } from '../constant';

export async function createActivitySession(params: { activityId: number; tlId: number; deviceId?: string }) {
    const formData = new FormData();

    formData.append('tl_id', params.tlId.toString());
    formData.append('activity_id', params.activityId.toString());
    if (params.deviceId != null) {
        formData.append('device_id', params.deviceId);
    }

    try {
        const { data } = await axios.post<Session>(`${Endpoints.Activity.Create}`, formData, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        });

        return data;
    } catch (error) {
        appClientCore.errorMapper(error as Error);
        throw error;
    }
}
